<template lang="pug">
    div#popup
        div.popup__wrap(:class="{'is-show': toggle}")
            form.popupFeedback(:class="{'is-show': toggle}" @submit.prevent="onSubmit()")
                div.titleBlock Обратная связь
                div.textBlock Здесь вы можете оставить свои пожелания, замечания или предложения
                div.icon-close(@click="onClose")
                    include ../snippets/close.pug

                div.msg__success.is-active(v-if="success" v-html="success")
                div.msg__error.is-active(v-if="errors" v-html="errors")
                div.formGroup.send
                    label.label
                        div.name Имя
                        input.input(type='text', v-model="data.name")
                    span.msg
                div.formGroup.send
                    label.label
                        div.name Фамилия
                        input.input(type='text', v-model="data.surname")
                    span.msg
                div.formGroup.send
                    label.label
                        div.name Сообщение
                        textarea.textarea(v-model="data.message")
                    span.msg
                button.btn.btn-green.btn-large.btnFeedback(type='submit') Отправить
        //popup__wrap
    //popup
</template>

<script>
    import FeedbackService from '@/services/Feedback';

    export default {
        name: "feedback-popup",
        template: '#popup',
        props: {
            toggle: {
                type: Boolean,
                required: true
            },
        },
        data() {
            return {
                data: {
                    name: '',
                    surname: '',
                    message: ''
                },
                success: null,
                errors: null,
                toggleLocal: this.toggle
            }
        },
        methods: {
            onClose() {
                this.$emit('close', this.toggleLocal, 'feedback');
            },
            async onSubmit() {
                if (this.data.name && this.data.surname && this.data.message) {
                    await FeedbackService.create(this.data);
                    this.errors = '';
                    this.data.name = '';
                    this.data.surname = '';
                    this.data.message = '';
                    this.success = 'Ваше сообщение успешно отправлено.';
                    setTimeout(() => {
                        this.success = null;
                    }, 2000);
                } else {
                    this.errors = '* Заполните все поля!';
                }
            }
        }
    }
</script>
